import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./ooraSideNav.css";

const OORA_NAV = [
  { label: "Job Logs", path: "/oora-job-logs" },
  { label: "Infra Dataset", path: "/oora-infra-dataset" },
//   { label: "Traffic Dataset", path: "/oora-traffic-dataset" },
  { label: "TomTom Traffic", path: "/oora_tomtom_traffic" },
];

const OoraSideNav = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <div className="oora-sidenav">
      <div className="oora-sidenav-title">Oora</div>
      {OORA_NAV.map((item) => {
        const isActive = pathname === item.path || pathname.startsWith(`${item.path}/`);
        return (
          <div
            key={item.path}
            className={`oora-sidenav-item ${isActive ? "active" : ""}`}
            onClick={() => navigate(item.path)}
          >
            {item.label}
          </div>
        );
      })}
    </div>
  );
};

export default OoraSideNav;